import React from 'react';

const AdminPanel = ({ history }) => {
  history.push('/admin/team');
  return <></>;
};

export default AdminPanel;
